import React, { useRef, useState } from 'react';
import { GuedelonButton } from '../bouton-guedelon/button';
import style from './block.module.scss';
import image from './img_newsletter.svg';
import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import { EditableText } from '@smartfire/components';
import apiFetch from '@wordpress/api-fetch';
import { useTranslation } from 'react-i18next';

const InspectorLazy = React.lazy(() => import('./Inspector'));
function Block({ api, language, thanksText, placeholder }) {
    useInspectorControl(InspectorLazy, []);
    const [submitted, setSubmitted] = useState('none');
    const inputRef = useRef<HTMLInputElement>(null);
    const [errorText, setErrorText] = useState('');
    const { t } = useTranslation();
    const newsletterFormHandler = (event) => {
        event.preventDefault();
        //TO DO : replace with smartform.
        // use smartProps api for listId
        // and smartProps language for language
        // to add in form body
        if (!isEditing) {
            const bodyData = new FormData();

            bodyData.append('email', inputRef.current?.value ?? '');
            bodyData.append('listId', api);
            bodyData.append('language', language);
            setSubmitted('');
            setErrorText('');
            apiFetch<any>({
                path: 'newsletter/subscribe',
                method: 'POST',
                body: bodyData,
            })
                .then(() => {
                    setSubmitted('ok');
                })
                .catch((err) => {
                    setSubmitted('erreur');
                    setErrorText(err.message);
                });
        }
    };
    const { isEditing } = useEditor();
    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.content}>
                <div className={style.middle}>
                    <EditableText
                        className={style.title}
                        placeholder={'Entrez un titre'}
                        smartProp="title"
                        tagName="h2"
                    />
                    <EditableText className={style.text} placeholder={'Entrez un texte'} smartProp="text" />
                    <form className={style.newsletter} onSubmit={newsletterFormHandler}>
                        <input ref={inputRef} type="email" placeholder={placeholder} required />
                        <label>
                            <input type="submit" disabled={isEditing && true} />
                            <GuedelonButton className={style.guedelonButton} href={undefined}>
                                <EditableText tagName="span" placeholder="ajouter un texte" smartProp="linkText" />
                            </GuedelonButton>
                        </label>
                    </form>
                    <div
                        className={
                            submitted === 'ok' ? style.valid : submitted === 'erreur' ? style.invalid : style.none
                        }
                    >
                        {submitted === 'ok' ? (
                            thanksText
                        ) : (
                            <>
                                {' '}
                                {t('Erreur')} : {errorText}
                            </>
                        )}
                    </div>
                </div>
                <img className={style.image} src={image} alt="illustration homme dans un puits" />
            </div>
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block: Block as React.FC<unknown>,
    smartProps: {
        title: smartProps.string.withDefault('Newsletter'),
        text: smartProps.string.withDefault(''),
        placeholder: smartProps.string.withDefault('Votre adresse mail'),
        api: smartProps.string.withDefault(''),
        linkText: smartProps.string.withDefault('s’inscrire'),
        thanksText: smartProps.string.withDefault('Merci de votre inscription'),
        language: smartProps.string.withDefault('fr'),
    },
    setup: {
        title: 'Newsletter',
        icon: 'email-alt',
    },
});
